var map = {
	"./enerji": "f604",
	"./enerji.js": "f604",
	"./konya": "1e8d",
	"./konya.js": "1e8d",
	"./mmesaj": "2a76",
	"./mmesaj.js": "2a76",
	"./mmesajprod": "83ab",
	"./mmesajprod.js": "83ab",
	"./spec": "ff7c",
	"./spec.js": "ff7c",
	"./spectest": "2ede",
	"./spectest.js": "2ede",
	"./spectim": "e7d2",
	"./spectim.js": "e7d2",
	"./tcdd": "8ba4",
	"./tcdd.js": "8ba4",
	"./tedasim": "3879",
	"./tedasim.js": "3879"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8a6";